import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LandingPageHeader: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Cabeçalho */}
      <header 
        className={`py-4 px-4 md:px-10 flex justify-between items-center fixed w-full z-50 transition-all duration-300 ${
          scrolled ? 'bg-[rgba(10,25,47,0.95)] backdrop-blur-md shadow-lg' : 'bg-[rgba(10,25,47,0.7)] backdrop-blur-sm'
        }`}
      >
        <div>
          <img src="/lognow_branco.svg" alt="LOGNOW" className="h-8" />
        </div>
        
        {/* Menu para desktop */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#como-funciona" className="text-white hover:text-[#8cc63f] transition-colors">Como Funciona</a>
          <a href="#produtos" className="text-white hover:text-[#8cc63f] transition-colors">Produtos</a>
          <a href="#marketplaces" className="text-white hover:text-[#8cc63f] transition-colors">Marketplaces</a>
          <a href="#planos" className="text-white hover:text-[#8cc63f] transition-colors">Planos</a>
        </div>
        
        <div className="hidden md:flex gap-4">
          <Link to="/login" className="px-6 py-2 rounded-lg bg-transparent border border-white hover:bg-white hover:text-[rgb(10,25,47)] transition-colors text-sm md:text-base">
            Aceder ao Painel
          </Link>
          <Link to="/register" className="px-6 py-2 rounded-lg bg-[#8cc63f] text-white hover:bg-[#7ab52f] transition-colors text-sm md:text-base">
            Registar
          </Link>
        </div>
        
        {/* Botão de menu mobile */}
        <div className="md:hidden">
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-white p-2"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>
      
      {/* Menu mobile */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 bg-[rgb(10,25,47)] z-40 pt-20 px-4 md:hidden">
          <div className="flex flex-col gap-6">
            <a 
              href="#como-funciona" 
              className="text-white text-xl py-3 border-b border-white/20"
              onClick={() => setMobileMenuOpen(false)}
            >
              Como Funciona
            </a>
            <a 
              href="#produtos" 
              className="text-white text-xl py-3 border-b border-white/20"
              onClick={() => setMobileMenuOpen(false)}
            >
              Produtos
            </a>
            <a 
              href="#marketplaces" 
              className="text-white text-xl py-3 border-b border-white/20"
              onClick={() => setMobileMenuOpen(false)}
            >
              Marketplaces
            </a>
            <a 
              href="#planos" 
              className="text-white text-xl py-3 border-b border-white/20"
              onClick={() => setMobileMenuOpen(false)}
            >
              Planos
            </a>
            
            <div className="flex flex-col gap-4 mt-6">
              <Link 
                to="/login" 
                className="px-6 py-3 rounded-lg bg-transparent border border-white hover:bg-white hover:text-[rgb(10,25,47)] transition-colors text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Aceder ao Painel
              </Link>
              <Link 
                to="/register" 
                className="px-6 py-3 rounded-lg bg-[#8cc63f] text-white hover:bg-[#7ab52f] transition-colors text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Registar
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Hero Banner */}
      <div className="relative pt-20">
        <div className="absolute inset-0 bg-gradient-to-r from-[rgba(10,25,47,0.9)] to-[rgba(10,25,47,0.7)] z-10"></div>
        <div className="absolute inset-0 bg-[url('/hero-ecommerce.jpg')] bg-cover bg-center opacity-30"></div>
        
        <div className={`relative z-20 py-24 px-4 md:px-10 max-w-7xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              <span className="text-white">Venda online </span>
              <span className="text-[#8cc63f]">sem stock</span>
              <br />
              <span className="text-white">e ganhe até </span>
              <span className="text-[#8cc63f]">40% de margem</span>
            </h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto mb-10 text-white/90">
              Aceda a mais de 200.000 produtos prontos a vender, integre com a sua loja ou marketplaces
              e nós tratamos de todo o processo de envio para os seus clientes
            </p>
            
            <div className="flex flex-col md:flex-row justify-center gap-6 mb-8">
              <Link to="/register" className="inline-block px-8 py-4 rounded-lg bg-[#8cc63f] text-white hover:bg-[#7ab52f] transition-colors text-xl font-bold transform hover:scale-105 transition-transform shadow-lg">
                COMEÇAR AGORA
              </Link>
              <a href="#planos" className="px-8 py-4 rounded-lg bg-transparent border-2 border-white text-white hover:bg-white hover:text-[rgb(10,25,47)] transition-colors text-xl font-bold">
                VER PLANOS
              </a>
            </div>
            
            <div className="bg-[rgba(255,255,255,0.1)] p-4 rounded-lg inline-block">
              <p className="text-lg text-white">Comece a vender em menos de 24 horas | Configuração rápida | Suporte dedicado</p>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[rgb(10,25,47)] to-transparent"></div>
      </div>
    </>
  );
};

export default LandingPageHeader;
